import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FloatingActionButton, MuiThemeProvider } from 'material-ui';
import ActionCode from 'material-ui/svg-icons/action/code';
import OperatorSelectionSelector from '../redux/selectors/OperatorSelectionSelector';
import {
  getLeftCheckedMailProcessingCenters,
  getLeftExpandedPostalOperators,
  getLeftPostalOperators,
  getRightCheckedMailProcessingCenters,
  getRightExpandedOperators,
  getRightPostalOperators,
} from '../../../user/redux/selectors/UserDataSelectors';
import {
  onLeftMailProcessingCenterChecked,
  onLeftPostalOperatorExpanded,
  onRightMailProcessingCenterChecked,
  onRightPostalOperatorExpanded,
  onSelectAllLeftMailProcessingCenters,
  onSelectAllRightMailProcessingCenters,
  onSwapTrees,
  onUnselectAllLeftMailProcessingCenters,
  onUnselectAllRightMailProcessingCenters,
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator,
  retrieveAllRightOperatorsWithImpcsRequestActionCreator,
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator,
  retrieveLeftGlobalImpcPresetRequestActionCreator,
  retrieveLeftOperatorsWithImpcsByRoleRequestActionCreator,
  retrieveRightAssetTypeOperatorsWithImpcsRequestActionCreator,
  retrieveRightGlobalImpcPresetRequestActionCreator,
  retrieveRightOperatorsWithImpcsByRoleRequestActionCreator,
} from '../redux/actions/OperatorImpcActions';
import { getAssetType } from '../../../asset-types/redux/selectors/AssetTypesSelectors';

export class OperatorImpcSelectionContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const leftParams = {
      assetType: this.props.appContext.appContext,
      useGlobalPresets: this.props.leftTree.useGlobalPresets,
    };

    if (this.props.leftTree.onlyAssetImpcs === true) {
      this.props.retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator();
    } else if (this.props.leftTree.roleFilter === true) {
      this.props.retrieveLeftOperatorsWithImpcsByRoleRequestActionCreator(leftParams);
    } else {
      this.props.retrieveAllLeftOperatorsWithImpcsRequestActionCreator(leftParams);
    }

    if (this.props.rightTree) {
      const rightParams = {
        assetType: this.props.appContext.appContext,
        useGlobalPresets: this.props.rightTree.useGlobalPresets,
      };

      if (this.props.rightTree.onlyAssetImpcs === true) {
        this.props.retrieveRightAssetTypeOperatorsWithImpcsRequestActionCreator();
      } else if (this.props.rightTree.roleFilter) {
        this.props.retrieveRightOperatorsWithImpcsByRoleRequestActionCreator(rightParams);
      } else {
        this.props.retrieveAllRightOperatorsWithImpcsRequestActionCreator(rightParams);
      }
    }
  }

  onExpandLeftPostalOperator = (expanded) => {
    this.props.onLeftPostalOperatorExpanded(expanded);
  };

  onExpandRightPostalOperator = (expanded) => {
    this.props.onRightPostalOperatorExpanded(expanded);
  };

  onSelectLeft = (selected) => {
    this.props.onLeftMailProcessingCenterChecked(selected);
  };

  onSelectRight = (selected) => {
    this.props.onRightMailProcessingCenterChecked(selected);
  };

  onSelectAllLeft = () => {
    this.props.onSelectAllLeftMailProcessingCenters(this.props.leftTree.postalOperatorNodes);
  };

  onSelectAllRight = () => {
    this.props.onSelectAllRightMailProcessingCenters(this.props.rightTree.postalOperatorNodes);
  };

  onUnselectedAllLeft = () => {
    this.props.onUnselectAllLeftMailProcessingCenters();
  };

  onUnselectedAllRight = () => {
    this.props.onUnselectAllRightMailProcessingCenters();
  };

  onSelectLeftContextType = () => {
    this.props.retrieveLeftGlobalImpcPresetRequestActionCreator(this.props.appContext.appContext);
  }

  onSelectRightContextType = () => {
    this.props.retrieveRightGlobalImpcPresetRequestActionCreator(this.props.appContext.appContext);
  }

  onSwapTrees = () => {
    this.props.onSwapTrees({
      newLeft: {
        nodes: this.props.rightTree.postalOperatorNodes,
        checkedMailProcessingCenters: this.props.rightTree.checkedMailProcessingCenters,
        expandedPostalOperators: this.props.rightTree.expandedPostalOperators,
      },
      newRight: {
        nodes: this.props.leftTree.postalOperatorNodes,
        checkedMailProcessingCenters: this.props.leftTree.checkedMailProcessingCenters,
        expandedPostalOperators: this.props.leftTree.expandedPostalOperators,
      },
    });
  };

  render() {
    return (
      <div>
        <div className="operator-div">
          <OperatorSelectionSelector
            title={this.props.leftTree.title}
            postalOperatorNodes={this.props.leftTree.postalOperatorNodes}
            checked={this.props.leftTree.checkedMailProcessingCenters}
            expanded={this.props.leftTree.expandedPostalOperators}
            onCheck={this.onSelectLeft}
            onExpand={this.onExpandLeftPostalOperator}
            onSelectAll={this.onSelectAllLeft}
            onDeSelectAll={this.onUnselectedAllLeft}
            appContextType={this.props.appContext.appContext}
            onContextClick={this.onSelectLeftContextType}
          />
          {this.props.rightTree && this.props.switchEnabled && (
            <div className="operator-divider">
              <MuiThemeProvider>
                <FloatingActionButton
                  onClick={this.onSwapTrees}
                  backgroundColor="#03adaa"
                  mini
                  style={{
                    zIndex: 1,
                    marginLeft: '-20px',
                    marginTop: '11px',
                    border: '5px solid #abe1e5',
                    boxShadow: 'none',
                  }}
                >
                  <ActionCode />
                </FloatingActionButton>
              </MuiThemeProvider>
            </div>
          )}
          {this.props.rightTree && (
            <OperatorSelectionSelector
              title={this.props.rightTree.title}
              postalOperatorNodes={this.props.rightTree.postalOperatorNodes}
              checked={this.props.rightTree.checkedMailProcessingCenters}
              expanded={this.props.rightTree.expandedPostalOperators}
              onCheck={this.onSelectRight}
              onExpand={this.onExpandRightPostalOperator}
              onSelectAll={this.onSelectAllRight}
              onDeSelectAll={this.onUnselectedAllRight}
              appContextType={this.props.appContext.appContext}
              onContextClick={this.onSelectRightContextType}
            />
          )}
        </div>
      </div>
    );
  }
}

OperatorImpcSelectionContainer.propTypes = {
  retrieveLeftOperatorsWithImpcsByRoleRequestActionCreator: PropTypes.func,
  retrieveRightOperatorsWithImpcsByRoleRequestActionCreator: PropTypes.func,
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  retrieveAllRightOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  retrieveLeftGlobalImpcPresetRequestActionCreator: PropTypes.func,
  retrieveRightGlobalImpcPresetRequestActionCreator: PropTypes.func,
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  retrieveRightAssetTypeOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  leftTree: PropTypes.shape({
    onlyAssetImpcs: PropTypes.bool,
    roleFilter: PropTypes.bool,
    title: PropTypes.string,
    useGlobalPresets: PropTypes.bool,
    postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
    expandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
    checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  }),
  rightTree: PropTypes.shape({
    onlyAssetImpcs: PropTypes.bool,
    roleFilter: PropTypes.bool,
    title: PropTypes.string,
    useGlobalPresets: PropTypes.bool,
    postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
    expandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
    checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  }),
  onLeftMailProcessingCenterChecked: PropTypes.func,
  onLeftPostalOperatorExpanded: PropTypes.func,
  onSelectAllLeftMailProcessingCenters: PropTypes.func,
  onUnselectAllLeftMailProcessingCenters: PropTypes.func,
  onRightMailProcessingCenterChecked: PropTypes.func,
  onRightPostalOperatorExpanded: PropTypes.func,
  onSelectAllRightMailProcessingCenters: PropTypes.func,
  onUnselectAllRightMailProcessingCenters: PropTypes.func,
  switchEnabled: PropTypes.bool,
  onSwapTrees: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.shape),
};

OperatorImpcSelectionContainer.defaultProps = {
  leftTree: {
    onlyAssetImpcs: false,
    roleFilter: true,
    title: 'OPERATOR & IMPC',
    useGlobalPresets: true,
  },
  switchEnabled: false,
};

const mapStateToProps = (state, props) => {
  let newProps = {
    appContext: getAssetType(state),
    leftTree: {
      ...OperatorImpcSelectionContainer.defaultProps.leftTree,
      ...props.leftTree,
      postalOperatorNodes: getLeftPostalOperators(state),
      expandedPostalOperators: getLeftExpandedPostalOperators(state),
      checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    },
  };

  if (props.rightTree) {
    newProps = {
      ...newProps,
      rightTree: {
        ...props.rightTree,
        postalOperatorNodes: getRightPostalOperators(state),
        expandedPostalOperators: getRightExpandedOperators(state),
        checkedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
      },
    };
  }

  return newProps;
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  retrieveLeftOperatorsWithImpcsByRoleRequestActionCreator,
  retrieveRightOperatorsWithImpcsByRoleRequestActionCreator,
  retrieveAllLeftOperatorsWithImpcsRequestActionCreator,
  retrieveAllRightOperatorsWithImpcsRequestActionCreator,
  retrieveLeftGlobalImpcPresetRequestActionCreator,
  retrieveRightGlobalImpcPresetRequestActionCreator,
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator,
  retrieveRightAssetTypeOperatorsWithImpcsRequestActionCreator,
  onLeftMailProcessingCenterChecked,
  onLeftPostalOperatorExpanded,
  onSelectAllLeftMailProcessingCenters,
  onUnselectAllLeftMailProcessingCenters,
  onRightMailProcessingCenterChecked,
  onRightPostalOperatorExpanded,
  onSelectAllRightMailProcessingCenters,
  onUnselectAllRightMailProcessingCenters,
  onSwapTrees,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OperatorImpcSelectionContainer);
